import { render, staticRenderFns } from "./UserContract.vue?vue&type=template&id=740a5a2c&"
import script from "./UserContract.vue?vue&type=script&lang=js&"
export * from "./UserContract.vue?vue&type=script&lang=js&"
import style0 from "./UserContract.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UserContract.vue"
export default component.exports